import { createFileRoute } from '@tanstack/react-router'
import { Integracao } from '@/features/integracao'
import { requireAdminOrAvaliador } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/integracao/')({
  beforeLoad: async () => {
    await requireAdminOrAvaliador()
  },
  component: Integracao,
})
